'use client';

import React from 'react';

import { createFirebaseApp } from '@/utils/firebase/analytics';

const TriggerAnalytics = () => {
  React.useEffect(() => {
    createFirebaseApp();
  }, []);

  return <div />;
};

export default TriggerAnalytics;
